// extracted by mini-css-extract-plugin
export default {"timeLabel":"TimeInterval_timeLabel__iJTLy"};